import { ShieldAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { useAuth } from '../auth/AuthProvider';
import type { Permission } from '../api/types';
import { EmptyState } from '../components/ui';

export function RequirePermission({ permission, children }: { permission: Permission; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(permission)) {
    return (
      <EmptyState title="Keine Berechtigung" icon={<ShieldAlert className="size-10" />}>
        Für diese Seite fehlt dir die Berechtigung.
      </EmptyState>
    );
  }
  return <>{children}</>;
}
